define(['underscore'], (_)=> {
    return ['JsonRPCService', (JsonRPCService)=> {
            
        var driverProcessService = {};
        
        driverProcessService.getCategoryList = ()=> {
            return {
                accident  : "Accident",
                claim     : "Claim",
                voilation : "Violation"
            };
        }
        
        driverProcessService.getAccidentList = ()=> {
            return {
                a: "Hit a parked car/hit another vehicle while backing up",
                b: "Hit a pedestrian/cyclist",
                c: "Hit a stationary object (other than a parked car)",
                d: "Rear-ended another vehicle",
                e: "Vehicle hit while merging/sideswiped",
                f: "Intersection accident",
                g: "My vehicle was rear-ended",
                h: "My vehicle was hit while parked",
                i: "My vehicle overturned",
                j: "Other accident"/*,
                k: "Windshield or glass damage",
                l: "Towing and labor",
                m: "Hit an animal",
                n: "Other claim (fire, theft, vandalism, etc.)"*/
            };
        } 
        
        driverProcessService.getClaimList = ()=> {
            return {
                a: "Windshield or glass damage",
                b: "Towing and labor",
                c: "Hit an animal",
                d: "Other claim (fire, theft, vandalism, etc.)" 
            };
        }
            
        driverProcessService.getVoilationList = ()=> {
            return {
                a: "Moving Violation (failure to yield, stop sign/light violation, etc.)",
                b: "Major Violation (driving while license suspended, driving while intoxicated, etc.)",
                c: "Speeding (1-15 MPH over posted limit)",
                d: "Speeding (16+ MPH over posted limit)"
            };
        }
        
        driverProcessService.getAssociationList = ()=> {
            return {
                a  : "American Legion/Legionnaires",
                b  : "AARP",
                c  : "BASS/Bassmaster",
                d  : "Carpenters Union",
                e  : "COSTCO",
                f  : "Sam's Club",
                g  : "Credit Union",
                h  : "National Guard",
                i  : "National Notary Association",
                j  : "NRA",
                k  : "Rural Letter Carriers",
                l  : "USC Alumni",
                m  : "None"
            };
        }
            
        driverProcessService.getAgeInYears = (dateOfBirth)=> {
                
            var birthDate = new Date(dateOfBirth.year, dateOfBirth.month, dateOfBirth.day);
            var birthYear = birthDate.getFullYear();
            var birthMonth = birthDate.getMonth();
            var birthDay = birthDate.getDate();

            var currentDate = new Date();
            var currentYear = currentDate.getFullYear();
            var currentMonth = currentDate.getMonth();
            var currentDay = currentDate.getDate();

            var age = currentYear - birthYear;
            var ageMonth = currentMonth - birthMonth;
            var ageDay = currentDay - birthDay;

            if (ageMonth < 0 || (ageMonth == 0 && ageDay < 0)) {
                age = parseInt(age) - 1;
            }

            return age;
        }
        
        driverProcessService.getDriverExperience = (dateOfBirth, ageFirstLicensed)=> {
            
            //console.log("getDriverExperience::dateOfBirth ",dateOfBirth);
                
            var currentAge = driverProcessService.getAgeInYears(dateOfBirth);

            var drivingExperience = currentAge - ageFirstLicensed;

            return drivingExperience;
        }
            
        driverProcessService.calcYearFirstLicensed = (dateOfBirth, ageFirstLicensed)=> {
                
            var drivingExperience = driverProcessService.getDriverExperience(dateOfBirth, ageFirstLicensed);

            var currentDate = new Date();
            var currentYear = currentDate.getFullYear();
            var yearFirstLicensed = currentYear - drivingExperience;

            return yearFirstLicensed;
        }
        
        driverProcessService.getVehicleUsageList = ()=> {
            return {
                "principal" : "More than 50%",
                "occasional" : "Less than 50%"
            };
        }
        
        // Get realation ship list
        driverProcessService.getRelationShipList = ()=> {
            return {
                "Spouse" : "Spouse",
                "Child" : "Child",
                "Relative" : "Relative",
                "OtherParty" : "Other"
            };
        }
        
        // Get description code
        driverProcessService.getDescCode = (description, stateCode) => { 
            
            var descriptionList = driverProcessService.getAccidentDescription();
            var descStateCodes = descriptionList[stateCode];           
            
            for(var key in descStateCodes){
                //console.log("key", key, descStateCodes[key], description);
                if(descStateCodes[key] === description){
                    return key;
                }
            }
            
            return null;
        }
        
        // Map pc accident/claim/voilation description for portal
        driverProcessService.mapAccidentListToPortal = (accidentVoilationList, stateCode)=> {           
            
            //console.log("MapAccidentListToPortal In:: ", accidentVoilationList, stateCode);
            var portalAccidentVoilationList = [];
            
            if(accidentVoilationList == undefined || accidentVoilationList.length == 0){
                return portalAccidentVoilationList;
            }           
            
            for(var idx in accidentVoilationList){
                
                var accidentVoilation = accidentVoilationList[idx];
                var descriptionPcCode = driverProcessService.getDescCode(accidentVoilation.description, stateCode);
                //console.log("descriptionPcCode:: ",accidentVoilation.description, descriptionPcCode);
                var category = driverProcessService.getPortalCategory(stateCode, descriptionPcCode);
                var categoryType = driverProcessService.getPortalCategoryType(stateCode, descriptionPcCode);
                var dateOfEvent = accidentVoilation.dateOfEvent;
                var amount = accidentVoilation.amount
                
                portalAccidentVoilationList.push({
                    category : category,
                    publicID : accidentVoilation.publicID,
                    type : categoryType,
                    amount : amount,
                    pcDescription: accidentVoilation.description,
                    description: accidentVoilation.description,
                    date : dateOfEvent,
                    editing : false,
                    remove : false
                });
            }  
            
            //console.log("MapAccidentListToPortal Out:: ", portalAccidentVoilationList);
            
            return portalAccidentVoilationList;
        };
        
        // Map portal accident/claim/voilation description for PC
        driverProcessService.mapAccidentListToPC = (accidentVoilationList, stateCode) => {
            
            //console.log("MapAccidentListToPC In::",accidentVoilationList);
            
            var descriptionList = driverProcessService.getAccidentDescription();
            var pcAccidentVoilationList = [];          
               
            for(var idx in accidentVoilationList){
                
                var accidentVoilation = accidentVoilationList[idx];
                var descriptionCode = null;
                //console.log("accidentVoilation ",accidentVoilation)

                if(accidentVoilation.category == "accident"){
                    if(accidentVoilation.type != null && accidentVoilation.type != undefined){
                    descriptionCode = driverProcessService.getAccidentDescriptionForPC(accidentVoilation.type, accidentVoilation.amount, accidentVoilation.date,stateCode);
               } else {
                descriptionCode = accidentVoilation.pcDescription
               }
                }
                else if(accidentVoilation.category == "claim"){
                    descriptionCode = driverProcessService.getClaimDescriptionForPC(accidentVoilation.type, accidentVoilation.amount, stateCode);
                }
                else if(accidentVoilation.category == "voilation"){
                    descriptionCode = driverProcessService.getVoilationDescriptionForPC(accidentVoilation.type, stateCode);
                }
                
                var desc = descriptionList[stateCode][descriptionCode];
                
                accidentVoilation.pcDescription = desc;
                
                pcAccidentVoilationList.push({
                    publicID : accidentVoilation.publicID,
                    dateOfEvent : accidentVoilation.date,
                    description : desc,
                    category : accidentVoilation.category,
                    amount : accidentVoilation.amount,
                    type : accidentVoilation.type
                });
            }
            
            //console.log("MapAccidentListToPC Out::", pcAccidentVoilationList);
            
            return pcAccidentVoilationList;
        };
        
        // Accident Category Portal Mapping
        driverProcessService.getPortalCategory = (stateCode, descriptionCode) => {
            
            // For NC
            // Accident: F35, F38, F39, F40, F41, F42
            // Claim: F36, F37
            // Voilation: A6, F2, F8, F30

            // For SC
            // Accident: A21
            // Claim: A10
            // Voilation: A3, A5, A11, A14	
            
            var portalCategory = {
                NC : {
                    F35 : "accident",
                   /* F38 : "accident",
                    F39 : "accident",
                    F40 : "accident",*/
                    F110 : "accident",
                    F111 : "accident",
                    F120 : "accident",
                    F121 : "accident",
                    F130 : "accident",
                    F131 : "accident",
                    F147 : "accident",
                    F148 : "accident",
                    F149 : "accident",
                    
                    F41 : "accident",
                    F42 : "accident",
                    F36 : "claim",
                    F37 : "claim",
                    A6  : "voilation",
                    F2  : "voilation",
                    F8  : "voilation",
                    F30 : "voilation"
                },
                SC : {
                    A21 : "accident",
                    A10 : "claim",
                    A3  : "voilation",
                    A5  : "voilation",
                    A11 : "voilation",
                    A14 : "voilation"
                }   
               
            };
            
             return portalCategory[stateCode][descriptionCode];
        };
        
        // Accident Category Type Portal Mapping
        driverProcessService.getPortalCategoryType = (stateCode, descriptionCode) => {
            
            var portalCategoryType = {
                NC : {
                    F35 : "g",
                    /*F38 : "a",
                    F39 : "b",
                    F40 : "a",*/
                    F41 : "d",
                    F42 : "a",
                    F36 : "a",
                    F37 : "b",
                    A6  : "a",
                    F2  : "c",
                    F8  : "d",
                    F30 : "b"
                },
                SC : {
                    A21 : "a",
                    A10 : "a",
                    A3  : "c",
                    A5  : "a",
                    A11 : "d",
                    A14 : "b"
                }
            };
            
            return portalCategoryType[stateCode][descriptionCode];
        };
        
        // Accident Description / Actual PC Mapping
        driverProcessService.getAccidentDescription = ()=> {
            
            return {
                NC : {
                    "A6"  : "FAIL TO REDUCE SPEED",
                    "F2"  : "SPEEDING",
                    "F8"  : "SPEED >20 MPH <55MPH",
                    "F30" : "DWI",
                    "F35" : "ACCIDENT NOT AT FAULT",
                    "F36" : "COMP LOSS",
                    "F37" : "TOWING LOSS",
                    /*"F38" : "AFA - PD ONLY 1,800 OR LESS",
                    "F39" : "AFA - BI 1,800 OR LESS",
                    "F40" : "AFA - PD ONLY >1,800 <3000",
                    "F41" : "AFA - PD ONLY 3,000 OR GREATER",
                    "F42" : "AFA - BI >1,800",*/
                    "F47" : "AFA - BI 1,800 OR LESS",
                    "F48" : "AFA - BI >1,800",
                    "F49" : "AFA - FATALITY",
                    "F110" : "AFA - PD ONLY <= 1800 PRIOR TO 3/1/16 or <= 1850 AFTER 3/1/16",
                    "F111" : "AFA - PD ONLY <= 1800 PRIOR TO 3/1/16 or <= 1850 AFTER 3/1/16 or <= 2300 after 10/1/17",
                    "F120" : "AFA - PD ONLY > 1800 <= 3000 PRIOR TO 3/1/16 or > 1850 <= 3085 AFTER 3/1/16",
                    "F121" : "AFA - PD ONLY > 1800 <= 3000 PRIOR TO 3/1/16 or > 1850 <= 3085 AFTER 3/1/16 or > 2300<3850 after 10/01/17",
                    "F130" : "AFA - PD ONLY > 3000 PRIOR TO 3/1/16 or > 3085 AFTER 3/1/16",
                    "F131" : "AFA - PD ONLY > 3000 PRIOR TO 3/1/16 or > 3085 AFTER 3/1/16 or >=3850 after 10/01/17"
                    
                },
                SC : {
                    "A3"  : "Speeding: minor <=15 mph over speed limit unless defined by state",
                    "A5"  : "Failure to yield; failure to stop at red light/stop sign; failure to comply with traffic signal; failure to yield to pedestrian",
                    "A10" : "At Fault Accident: Minor (greater than 12 months old)",
                    "A11" : "Speeding: major >15 mph over speed limit unless defined by state",
                    "A14" : "Driver's license convictions: Driving while license suspended/ revoked/invalid; unlawful use of license; permit unlicensed person to drive (does not include failure to have license in your possession).",
                    "A21" : "At Fault Accident: Major (less than or equal to 12 months old)"
                }
            }
        };
        
        // Get Accident Description For PC Mapping
        driverProcessService.getAccidentDescriptionForPC = (option, amount, date,stateCode) => {
            
            if(stateCode == "NC"){
                return driverProcessService.getAccidentDescriptionForNC(option, amount , date);
            }
            else if(stateCode == "SC"){
                return driverProcessService.getAccidentDescriptionForSC(option, amount);
            }
        };
        
        // Get Claim Description For PC Mapping
        driverProcessService.getClaimDescriptionForPC = (option, amount, stateCode) => {
            
            if (stateCode == "NC"){
                return driverProcessService.getClaimDescriptionForNC(option, amount);
            }
            else if (stateCode == "SC"){
                return driverProcessService.getClaimDescriptionForSC(option, amount);
            }
        };
        
        // Get Voilation Description For PC Mapping
        driverProcessService.getVoilationDescriptionForPC = (option, stateCode) => {
            if (stateCode == "NC"){
                return driverProcessService.getVoilationDescriptionForNC(option);
            }
            else if (stateCode == "SC"){
                return driverProcessService.getVoilationDescriptionForSC(option);
            }
        };
        
        // Get accident description for state NC
        driverProcessService.getAccidentDescriptionForNC = (option, amount ,date)=> {
            
            amount = parseInt(amount);
            var eventDate = new Date(date.year, date.month, date.day)
            var accidentDate = new Date(2016, 2, 1)
            var accidentDate1 = new Date(2017, 9, 1)
                                    
            if(option == "a") {

            if(amount <= 1800 && eventDate.getTime() <= accidentDate.getTime()) {
               return "F110";
             }else if(amount <= 1850 && eventDate.getTime() >= accidentDate.getTime()) {
               return "F110";
             } else if(amount <= 2300 && eventDate.getTime() >= accidentDate1.getTime()) {
             return "F111";
             } else if((amount > 1800 && amount <= 3000 && eventDate.getTime() <= accidentDate.getTime()) ||
                (amount > 1850 && amount <= 3085 && eventDate.getTime() >= accidentDate.getTime())) {
             return "F120";
             } else if(amount > 2300 && amount < 3850 && eventDate.getTime() >= accidentDate1.getTime()) {
             return "F121";
             }else if((amount > 3000 && eventDate.getTime() <= accidentDate.getTime()) || 
                    (amount > 3085 && eventDate.getTime() >= accidentDate.getTime())) {
             return "F130";
             } else if(amount >= 3850 && eventDate.getTime() >= accidentDate1.getTime()) {
             return "F131";
             }
                /*if(amount < 1800){
                    return "F39";
                }                
                else if (amount > 1800 && amount < 3000){
                    return "F40";
                }
                // Check with Iris
                else {
                    return "F38";
                }*/
            }
            else if(option == "b"){
                
                if (amount <= 1800){
                    return "F47";
                }                
                else if (amount > 1800){
                    return "F48";
                }
                // Check with Iris
                else{
                    return "F49";
                }
            }
            else if (option == "c") {
                if(amount <= 1800 && eventDate.getTime() <= accidentDate.getTime()) {
               return "F110";
             }else if(amount <= 1850 && eventDate.getTime() >= accidentDate.getTime()) {
               return "F110";
             } else if(amount <= 2300 && eventDate.getTime() >= accidentDate1.getTime()) {
             return "F111";
             } else if((amount > 1800 && amount <= 3000 && eventDate.getTime() <= accidentDate.getTime()) ||
                (amount > 1850 && amount <= 3085 && eventDate.getTime() >= accidentDate.getTime())) {
             return "F120";
             } else if(amount > 2300 && amount < 3850 && eventDate.getTime() >= accidentDate1.getTime()) {
             return "F121";
             }else if((amount > 3000 && eventDate.getTime() <= accidentDate.getTime()) || 
                    (amount > 3085 && eventDate.getTime() >= accidentDate.getTime())) {
             return "F130";
             } else if(amount >= 3850 && eventDate.getTime() >= accidentDate1.getTime()) {
             return "F131";
             }

                /*if (amount < 1800){
                    return "F38";
                }
                else if (amount > 1800 && amount < 3000){
                    return "F40";
                }
                else if(amount > 3000){
                    return "F41";
                }
                // Check with Iris
                else{
                    return "F38";
                }*/
            }
            else if (option == "d" || option == "f") {
              if(amount <= 1800 && eventDate.getTime() <= accidentDate.getTime()) {
               return "F110";
             }else if(amount <= 1850 && eventDate.getTime() >= accidentDate.getTime()) {
               return "F110";
             } else if(amount <= 2300 && eventDate.getTime() >= accidentDate1.getTime()) {
             return "F111";
             } else if((amount > 1800 && amount <= 3000 && eventDate.getTime() <= accidentDate.getTime()) ||
                (amount > 1850 && amount <= 3085 && eventDate.getTime() >= accidentDate.getTime())) {
             return "F120";
             } else if(amount > 2300 && amount < 3850 && eventDate.getTime() >= accidentDate1.getTime()) {
             return "F121";
             }else if((amount > 3000 && eventDate.getTime() <= accidentDate.getTime()) || 
                    (amount > 3085 && eventDate.getTime() >= accidentDate.getTime())) {
             return "F130";
             } else if(amount >= 3850 && eventDate.getTime() >= accidentDate1.getTime()) {
             return "F131";
             }

               /* if (amount > 1800 && amount < 3000){
                    return "F40";
                }
                else if(amount > 3000){
                    return "F41";
                }
                // Check with Iris
                else{
                    return "F40";
                }*/
            }     
            else if (option == "e"){
              if(amount <= 1800 && eventDate.getTime() <= accidentDate.getTime()) {
               return "F110";
             }else if(amount <= 1850 && eventDate.getTime() >= accidentDate.getTime()) {
               return "F110";
             } else if(amount <= 2300 && eventDate.getTime() >= accidentDate1.getTime()) {
             return "F111";
             } else if((amount > 1800 && amount <= 3000 && eventDate.getTime() <= accidentDate.getTime()) ||
                (amount > 1850 && amount <= 3085 && eventDate.getTime() >= accidentDate.getTime())) {
             return "F120";
             } else if(amount > 2300 && amount < 3850 && eventDate.getTime() >= accidentDate1.getTime()) {
             return "F121";
             }else if((amount > 3000 && eventDate.getTime() <= accidentDate.getTime()) || 
                    (amount > 3085 && eventDate.getTime() >= accidentDate.getTime())) {
             return "F130";
             } else if(amount >= 3850 && eventDate.getTime() >= accidentDate1.getTime()) {
             return "F131";
             }
                /*if (amount > 1800 && amount < 3000){
                    return "F40";
                }
                else if (amount > 3000){
                    return "F41";
                }
                // Check with Iris
                else{
                    return "F40";
                }*/
            }
            else if (option == "g" || option == "h" || option == "j"){
                return "F35";
            }
            else if (option == "i") {
              if(amount <= 1800 && eventDate.getTime() <= accidentDate.getTime()) {
               return "F110";
             }else if(amount <= 1850 && eventDate.getTime() >= accidentDate.getTime()) {
               return "F110";
             } else if(amount <= 2300 && eventDate.getTime() >= accidentDate1.getTime()) {
             return "F111";
             } else if((amount > 1800 && amount <= 3000 && eventDate.getTime() <= accidentDate.getTime()) ||
                (amount > 1850 && amount <= 3085 && eventDate.getTime() >= accidentDate.getTime())) {
             return "F120";
             } else if(amount > 2300 && amount < 3850 && eventDate.getTime() >= accidentDate1.getTime()) {
             return "F121";
             }else if((amount > 3000 && eventDate.getTime() <= accidentDate.getTime()) || 
                    (amount > 3085 && eventDate.getTime() >= accidentDate.getTime())) {
             return "F130";
             } else if(amount >= 3850 && eventDate.getTime() >= accidentDate1.getTime()) {
             return "F131";
             }
                /*if (amount > 3000){
                    return "F41";
                }
                // Check with Iris
                else{
                    return "F41";
                }*/
            }
        };
        
        // Get claim description for state NC
        driverProcessService.getClaimDescriptionForNC = (option, amount)=> {
            
            amount = parseInt(amount);
            
            if(option == "a" || option == "c"){
                return "F36";
            }
            else if(option == "b"){
                return "F37";
            }
            else if (option == "d"){
                return "F35";
            }

        };
        
        // Get voilation description for state NC
        driverProcessService.getVoilationDescriptionForNC = (option)=> {
            
            if (option == "a"){
                return "A6";
            }
            else if (option == "b"){
                return "F30";
            }
            else if (option == "c"){
                return "F2";
            }
            else if (option == "d"){
                return "F8";
            }
            
        };
        
        // Get accident description for state SC
        driverProcessService.getAccidentDescriptionForSC = (option) => {
            
            return "A21";
        };
        
        // Get claim description for state SC
        driverProcessService.getClaimDescriptionForSC = (option) => {
            return "A10";
        };
        
        // Get voilation description for state SC
        driverProcessService.getVoilationDescriptionForSC = (option) => {
            if (option == "a"){
                return "A5";
            }
            else if (option == "b"){
                return "A14";
            }
            else if (option == "c"){
                return "A3";
            }
            else if (option == "d"){
                return "A11";
            }
        };
        
        // Return DriverProcessService
        return driverProcessService;
    
    }];
});


/** WEBPACK FOOTER **
 ** ./app/customer/js/src/edge/policyjob/services/DriverProcessService.js
 **/